/**
 * This client was automatically generated by RudderTyper. ** Do Not Edit **
 */

import type {
  RudderAnalytics,
  RudderAnalyticsPreloader,
  ApiOptions,
  ApiObject,
} from '@rudderstack/analytics-js'
/**
 * The analytics instance should be available via window.rudderanalytics.
 * You can install it by following instructions at: https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/installation/
 */
declare global {
  interface Window {
    rudderanalytics: RudderAnalytics | RudderAnalyticsPreloader | undefined
  }
}

type apiCallback = (data?: any) => void

export enum Clicktype_String {
  S_LINK = 'link',
  S_BUTTON = 'button',
  S_NAVIGATION = 'navigation',
  S_FILTER = 'filter',
  S_DROPDOWN = 'dropdown',
}

export interface AlertToggled {
  alertName?: string
  destinationId?: string
  organizationId?: string
  profileId?: string
  resourceCategory?: string
  resourceType?: string
  sourceId?: string
  toggleValue?: boolean
  workspaceId?: string
}

export interface BotDetectionToggled {
  toggleValue: boolean
}

export interface CatalogAddNewEvent {
  category?: string
  eventName?: string
  eventType: string
}

export interface CatalogAddNewProperty {
  propertyName?: string
  propertyType: string
}

export interface CatalogDeleteEvent {
  category?: string
  eventName?: string
  eventType?: string
}

export interface CatalogDeleteProperty {
  propertyName?: string
  propertyType?: string
}

export interface ChannelToggled {
  channelType?: string
  organizationId?: string
  resourceCategory?: string
  toggleValue?: boolean
  workspaceId?: string
}

export interface ClickAddTrackingPlan {
  trackingPlanImportType?: string
}

export interface ClickMigrateTrackingPlan {
  migrationStatus: string
  trackingPlanId: string
  trackingPlanName: string
  trackingPlanVersion: string
}

export interface ClickWebApp {
  clickAppSection?: string
  clickCtaName?: string
  clickTargetUrl?: string
  clickType?: Clicktype_String
  organizationId?: string
  workspaceId?: string
}

export interface DestinationCreated {
  destinationId?: string
  destinationType?: string
  organizationId?: string
  workspaceId?: string
}

export interface DestinationDeleted {
  destinationId?: string
  destinationType?: string
  organizationId?: string
  workspaceId?: string
}

export interface DestinationDisabled {
  destinationId?: string
  destinationType?: string
  organizationId?: string
  workspaceId?: string
}

export interface DestinationSetupStarted {
  destinationType?: string
  organizationId?: string
  workspaceId?: string
}

export interface DestinationSetupStepCompleted {
  destinationType?: string
  organizationId?: string
  step?: number
  workspaceId?: string
}

export interface GettingStartedChecklistCompleted {
  organizationId?: string
  workspaceId?: string
}

export interface HealthTabViewed {
  organizationId?: string
  resourceCategory?: string
  workspaceId?: string
}

export interface IdeProjectCommit {
  clickCtaName?: string
  organizationId?: string
  projectId?: string
  workspaceId?: string
}

export interface IdeProjectCreate {
  clickCtaName?: string
  organizationId?: string
  workspaceId?: string
}

export interface IdeProjectOpen {
  clickCtaName?: string
  organizationId?: string
  projectId?: string
  workspaceId?: string
}

export interface IdeProjectRun {
  clickCtaName?: string
  organizationId?: string
  projectId?: string
  workspaceId?: string
}

export interface IdeProjectSave {
  clickCtaName?: string
  organizationId?: string
  projectId?: string
  workspaceId?: string
}

export interface Login {
  authMethod?: string
  organizationId?: string
  workspaceId?: string
}

export interface NewTransformationCreated {
  organizationId?: string
  transformationId?: string
  transformationLanguageType?: string
  transformationName?: string
  transformationTemplateType?: string
  transformationType?: string
  workspaceId?: string
}

export interface NewTransformationViewed {
  organizationId?: string
  transformationTemplateType?: string
  usersId?: string
  workspaceId?: string
}

export interface ResourceAlertsViewed {
  destinationId?: string
  organizationId?: string
  profileId?: string
  resourceCategory?: string
  resourceType?: string
  sourceId?: string
  workspaceId?: string
}

export interface ResourceSelected {
  destinationId?: string
  organizationId?: string
  resourceCategory?: string
  sourceId?: string
  trackingPlanId?: string
  workspaceId?: string
}

export interface SourceCreated {
  organizationId?: string
  sourceId?: string
  sourceType?: string
  workspaceId?: string
}

export interface SourceDeleted {
  organizationId?: string
  sourceId?: string
  sourceType?: string
  workspaceId?: string
}

export interface SourceDisabled {
  organizationId?: string
  sourceId?: string
  sourceType?: string
  workspaceId?: string
}

export interface SourceSetupStarted {
  organizationId?: string
  sourceType?: string
  workspaceId?: string
}

export interface SourceSetupStepCompleted {
  organizationId?: string
  sourceType?: string
  step?: number
  workspaceId?: string
}

export interface TrackingPlanConnected {
  sourceId?: any[]
  sourceName?: any[]
  trackingPlanId?: string
  trackingPlanName?: string
}

export interface TrackingPlanCreated {
  trackingPlanId?: string
  trackingPlanName?: string
}

export interface TrackingPlanDraftCreated {
  trackingPlanId?: string
  trackingPlanName?: string
}

export interface TrackingPlanDropEventsTriggered {
  trackingPlanId?: string
  trackingPlanName?: string
}

export interface TrackingPlanEdited {
  trackingPlanId?: string
  trackingPlanName?: string
}

export interface TrackingPlanEventsViewed {
  trackingPlanId?: string
}

export interface TransformationConnectedToDestination {
  destinationId?: string
  destinationMode?: string
  organizationId?: string
  transformationId?: string
  workspaceId?: string
}

export interface TransformationDeleted {
  destinationMode?: string
  organizationId?: string
  transformationId?: string
  transformationLanguageType?: string
  workspaceId?: string
}

export interface TransformationDiffViewed {
  organizationId?: string
  transformationId?: string
  transformationLanguageType?: string
  workspaceId?: string
}

export interface TransformationDisconnectedFromDestination {
  destinationId?: string
  organizationId?: string
  transformationId?: string
  workspaceId?: string
}

export interface TransformationEventsPageViewed {
  organizationId?: string
  transformationId?: string
  workspaceId?: string
}

export interface TransformationLibraryCreated {
  libraryId?: string
  organizationId?: string
  workspaceId?: string
}

export interface TransformationLogs {
  organizationId?: string
  transformationId?: string
  transformationLanguageType?: string
  workspaceId?: string
}

export interface TransformationSplitScreen {
  organizationId?: string
  splitDirection?: string
  transformationId?: string
  transformationLanguageType?: string
  workspaceId?: string
}

export interface TransformationTested {
  organizationId?: string
  transformationId?: string
  transformationLanguageType?: string
  workspaceId?: string
}

export interface UserCompletedOnboarding {
  onboardingQuestionsStatus?: string
  organizationId?: string
  questionHowDidYouHear?: string
  questionMigratingFrom?: string
  questionProductInterest?: any[]
  userCompanyRole?: any[]
  workspaceId?: string
}

export interface ViewedLiveEvents {
  organizationId?: string
  resourceType?: string
  workspaceId?: string
}

export interface WorkspaceAlertsViewed {
  organizationId?: string
  resourceCategory?: string
  workspaceId?: string
}

export interface Group {
  account_type?: string
  company?: string
  email?: string
  firstName?: string
  first_login?: boolean
  jobTitle?: string
  lastName?: string
  logins?: number
  name?: string
  onboardingQuestionsStatus?: string
  organizationId?: string
  plan?: string
  questionHowDidYouHear?: string
  questionMigratingFrom?: string
  questionProductInterest?: any[]
  raid?: string
  userCompanyRole?: any[]
  userId?: string
  workspaceId?: string
}

export interface Identify {
  account_type?: string
  company?: string
  created_at?: string
  email?: string
  first_login?: boolean
  jobTitle?: string
  logins?: number
  name?: string
  onboardingQuestionsStatus?: string
  organizationId?: string
  plan?: string
  questionHowDidYouHear?: string
  questionMigratingFrom?: string
  questionProductInterest?: any[]
  role?: string
  userCompanyRole?: any[]
  userId?: string
  workspaceId?: string
}

export type ViolationHandler = (
  message: Record<string, any>,
  violations: any[]
) => void

let analytics: () => any | undefined = () => {
  return window.rudderanalytics
}

/** Options to customize the runtime behavior of a RudderTyper client. */
export interface RudderTyperOptions {
  /**
   * Underlying analytics instance where analytics calls are forwarded on to.
   * Defaults to window.rudderanalytics.
   */
  analytics?: any
  /**
   * Handler fired when if an event does not match its spec. This handler
   * does not fire in production mode, because it requires inlining the full
   * JSON Schema spec for each event in your Tracking Plan.
   *
   * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
   * if a message does not match the spec. Otherwise, errors will be logged to stderr.
   */
  onViolation?: ViolationHandler
}

/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setRudderTyperOptions(options: RudderTyperOptions) {
  analytics = options.analytics
    ? () => options.analytics || window.rudderanalytics
    : analytics
}

/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext(message: ApiOptions = {}): ApiOptions {
  return {
    ...message,
    context: {
      ...((message.context as ApiObject) || {}),
      ruddertyper: {
        sdk: 'analytics.js',
        language: 'typescript',
        rudderTyperVersion: '1.6.1',
        trackingPlanId: 'tp_2rlqY6vQhJN4tyQnziWih15krHG',
        trackingPlanVersion: 13,
      },
    },
  }
}

/**
 * @typedef AlertToggled
 * @property {string} [alertName] -
 * @property {string} [destinationId] -
 * @property {string} [organizationId] -
 * @property {string} [profileId] -
 * @property {string} [resourceCategory] -
 * @property {string} [resourceType] -
 * @property {string} [sourceId] -
 * @property {boolean} [toggleValue] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef BotDetectionToggled
 * @property {boolean} toggleValue -
 */
/**
 * @typedef CatalogAddNewEvent
 * @property {string} [category] -
 * @property {string} [eventName] -
 * @property {string} eventType -
 */
/**
 * @typedef CatalogAddNewProperty
 * @property {string} [propertyName] -
 * @property {string} propertyType -
 */
/**
 * @typedef CatalogDeleteEvent
 * @property {string} [category] -
 * @property {string} [eventName] -
 * @property {string} [eventType] -
 */
/**
 * @typedef CatalogDeleteProperty
 * @property {string} [propertyName] -
 * @property {string} [propertyType] -
 */
/**
 * @typedef ChannelToggled
 * @property {string} [channelType] -
 * @property {string} [organizationId] -
 * @property {string} [resourceCategory] -
 * @property {boolean} [toggleValue] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef ClickAddTrackingPlan
 * @property {string} [trackingPlanImportType] -
 */
/**
 * @typedef ClickMigrateTrackingPlan
 * @property {string} migrationStatus -
 * @property {string} trackingPlanId -
 * @property {string} trackingPlanName -
 * @property {string} trackingPlanVersion -
 */
/**
 * @typedef ClickWebApp
 * @property {string} [clickAppSection] -
 * @property {string} [clickCtaName] -
 * @property {string} [clickTargetUrl] -
 * @property {Clicktype_String} [clickType] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef DestinationCreated
 * @property {string} [destinationId] -
 * @property {string} [destinationType] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef DestinationDeleted
 * @property {string} [destinationId] -
 * @property {string} [destinationType] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef DestinationDisabled
 * @property {string} [destinationId] -
 * @property {string} [destinationType] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef DestinationSetupStarted
 * @property {string} [destinationType] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef DestinationSetupStepCompleted
 * @property {string} [destinationType] -
 * @property {string} [organizationId] -
 * @property {number} [step] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef GettingStartedChecklistCompleted
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef HealthTabViewed
 * @property {string} [organizationId] -
 * @property {string} [resourceCategory] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef IdeProjectCommit
 * @property {string} [clickCtaName] -
 * @property {string} [organizationId] -
 * @property {string} [projectId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef IdeProjectCreate
 * @property {string} [clickCtaName] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef IdeProjectOpen
 * @property {string} [clickCtaName] -
 * @property {string} [organizationId] -
 * @property {string} [projectId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef IdeProjectRun
 * @property {string} [clickCtaName] -
 * @property {string} [organizationId] -
 * @property {string} [projectId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef IdeProjectSave
 * @property {string} [clickCtaName] -
 * @property {string} [organizationId] -
 * @property {string} [projectId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef Login
 * @property {string} [authMethod] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef NewTransformationCreated
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [transformationLanguageType] -
 * @property {string} [transformationName] -
 * @property {string} [transformationTemplateType] -
 * @property {string} [transformationType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef NewTransformationViewed
 * @property {string} [organizationId] -
 * @property {string} [transformationTemplateType] -
 * @property {string} [usersId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef ResourceAlertsViewed
 * @property {string} [destinationId] -
 * @property {string} [organizationId] -
 * @property {string} [profileId] -
 * @property {string} [resourceCategory] -
 * @property {string} [resourceType] -
 * @property {string} [sourceId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef ResourceSelected
 * @property {string} [destinationId] -
 * @property {string} [organizationId] -
 * @property {string} [resourceCategory] -
 * @property {string} [sourceId] -
 * @property {string} [trackingPlanId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef SourceCreated
 * @property {string} [organizationId] -
 * @property {string} [sourceId] -
 * @property {string} [sourceType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef SourceDeleted
 * @property {string} [organizationId] -
 * @property {string} [sourceId] -
 * @property {string} [sourceType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef SourceDisabled
 * @property {string} [organizationId] -
 * @property {string} [sourceId] -
 * @property {string} [sourceType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef SourceSetupStarted
 * @property {string} [organizationId] -
 * @property {string} [sourceType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef SourceSetupStepCompleted
 * @property {string} [organizationId] -
 * @property {string} [sourceType] -
 * @property {number} [step] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TrackingPlanConnected
 * @property {any[]} [sourceId] -
 * @property {any[]} [sourceName] -
 * @property {string} [trackingPlanId] -
 * @property {string} [trackingPlanName] -
 */
/**
 * @typedef TrackingPlanCreated
 * @property {string} [trackingPlanId] -
 * @property {string} [trackingPlanName] -
 */
/**
 * @typedef TrackingPlanDraftCreated
 * @property {string} [trackingPlanId] -
 * @property {string} [trackingPlanName] -
 */
/**
 * @typedef TrackingPlanDropEventsTriggered
 * @property {string} [trackingPlanId] -
 * @property {string} [trackingPlanName] -
 */
/**
 * @typedef TrackingPlanEdited
 * @property {string} [trackingPlanId] -
 * @property {string} [trackingPlanName] -
 */
/**
 * @typedef TrackingPlanEventsViewed
 * @property {string} [trackingPlanId] -
 */
/**
 * @typedef TransformationConnectedToDestination
 * @property {string} [destinationId] -
 * @property {string} [destinationMode] -
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationDeleted
 * @property {string} [destinationMode] -
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [transformationLanguageType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationDiffViewed
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [transformationLanguageType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationDisconnectedFromDestination
 * @property {string} [destinationId] -
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationEventsPageViewed
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationLibraryCreated
 * @property {string} [libraryId] -
 * @property {string} [organizationId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationLogs
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [transformationLanguageType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationSplitScreen
 * @property {string} [organizationId] -
 * @property {string} [splitDirection] -
 * @property {string} [transformationId] -
 * @property {string} [transformationLanguageType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef TransformationTested
 * @property {string} [organizationId] -
 * @property {string} [transformationId] -
 * @property {string} [transformationLanguageType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef UserCompletedOnboarding
 * @property {string} [onboardingQuestionsStatus] -
 * @property {string} [organizationId] -
 * @property {string} [questionHowDidYouHear] -
 * @property {string} [questionMigratingFrom] -
 * @property {any[]} [questionProductInterest] -
 * @property {any[]} [userCompanyRole] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef ViewedLiveEvents
 * @property {string} [organizationId] -
 * @property {string} [resourceType] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef WorkspaceAlertsViewed
 * @property {string} [organizationId] -
 * @property {string} [resourceCategory] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef Group
 * @property {string} [account_type] -
 * @property {string} [company] -
 * @property {string} [email] -
 * @property {string} [firstName] -
 * @property {boolean} [first_login] -
 * @property {string} [jobTitle] -
 * @property {string} [lastName] -
 * @property {number} [logins] -
 * @property {string} [name] -
 * @property {string} [onboardingQuestionsStatus] -
 * @property {string} [organizationId] -
 * @property {string} [plan] -
 * @property {string} [questionHowDidYouHear] -
 * @property {string} [questionMigratingFrom] -
 * @property {any[]} [questionProductInterest] -
 * @property {string} [raid] -
 * @property {any[]} [userCompanyRole] -
 * @property {string} [userId] -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef Identify
 * @property {string} [account_type] -
 * @property {string} [company] -
 * @property {string} [created_at] -
 * @property {string} [email] -
 * @property {boolean} [first_login] -
 * @property {string} [jobTitle] -
 * @property {number} [logins] -
 * @property {string} [name] -
 * @property {string} [onboardingQuestionsStatus] -
 * @property {string} [organizationId] -
 * @property {string} [plan] -
 * @property {string} [questionHowDidYouHear] -
 * @property {string} [questionMigratingFrom] -
 * @property {any[]} [questionProductInterest] -
 * @property {string} [role] -
 * @property {any[]} [userCompanyRole] -
 * @property {string} [userId] -
 * @property {string} [workspaceId] -
 */

/**
 * Fires a 'alertToggled' track call.
 *
 * @param {AlertToggled} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function alertToggled(
  props?: AlertToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'alertToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * This event is triggered when bot detection is enabled or disabled
 *
 * @param {BotDetectionToggled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function botDetectionToggled(
  props: BotDetectionToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'botDetectionToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New event was added in the Data Catalog
 *
 * @param {CatalogAddNewEvent} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogAddNewEvent(
  props: CatalogAddNewEvent,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogAddNewEvent',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'catalogAddNewProperty' track call.
 *
 * @param {CatalogAddNewProperty} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogAddNewProperty(
  props: CatalogAddNewProperty,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogAddNewProperty',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'catalogDeleteEvent' track call.
 *
 * @param {CatalogDeleteEvent} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogDeleteEvent(
  props?: CatalogDeleteEvent,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogDeleteEvent',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'catalogDeleteProperty' track call.
 *
 * @param {CatalogDeleteProperty} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogDeleteProperty(
  props?: CatalogDeleteProperty,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogDeleteProperty',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'channelToggled' track call.
 *
 * @param {ChannelToggled} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function channelToggled(
  props?: ChannelToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'channelToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'clickAddTrackingPlan' track call.
 *
 * @param {ClickAddTrackingPlan} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function clickAddTrackingPlan(
  props?: ClickAddTrackingPlan,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'clickAddTrackingPlan',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'clickMigrateTrackingPlan' track call.
 *
 * @param {ClickMigrateTrackingPlan} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function clickMigrateTrackingPlan(
  props: ClickMigrateTrackingPlan,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'clickMigrateTrackingPlan',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'clickWebApp' track call.
 *
 * @param {ClickWebApp} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function clickWebApp(
  props?: ClickWebApp,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'clickWebApp',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'destinationCreated' track call.
 *
 * @param {DestinationCreated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationCreated(
  props?: DestinationCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'destinationDeleted' track call.
 *
 * @param {DestinationDeleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationDeleted(
  props?: DestinationDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'destinationDisabled' track call.
 *
 * @param {DestinationDisabled} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationDisabled(
  props?: DestinationDisabled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationDisabled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'destinationSetupStarted' track call.
 *
 * @param {DestinationSetupStarted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationSetupStarted(
  props?: DestinationSetupStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationSetupStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'destinationSetupStepCompleted' track call.
 *
 * @param {DestinationSetupStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationSetupStepCompleted(
  props?: DestinationSetupStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationSetupStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'gettingStartedChecklistCompleted' track call.
 *
 * @param {GettingStartedChecklistCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function gettingStartedChecklistCompleted(
  props?: GettingStartedChecklistCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'gettingStartedChecklistCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'healthTabViewed' track call.
 *
 * @param {HealthTabViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function healthTabViewed(
  props?: HealthTabViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'healthTabViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'ideProjectCommit' track call.
 *
 * @param {IdeProjectCommit} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function ideProjectCommit(
  props?: IdeProjectCommit,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'ideProjectCommit',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'ideProjectCreate' track call.
 *
 * @param {IdeProjectCreate} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function ideProjectCreate(
  props?: IdeProjectCreate,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'ideProjectCreate',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'ideProjectOpen' track call.
 *
 * @param {IdeProjectOpen} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function ideProjectOpen(
  props?: IdeProjectOpen,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'ideProjectOpen',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'ideProjectRun' track call.
 *
 * @param {IdeProjectRun} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function ideProjectRun(
  props?: IdeProjectRun,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'ideProjectRun',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'ideProjectSave' track call.
 *
 * @param {IdeProjectSave} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function ideProjectSave(
  props?: IdeProjectSave,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'ideProjectSave',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'login' track call.
 *
 * @param {Login} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function login(
  props?: Login,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track('login', props || {}, withRudderTyperContext(options), callback)
  }
}
/**
 * Fires a 'newTransformationCreated' track call.
 *
 * @param {NewTransformationCreated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function newTransformationCreated(
  props?: NewTransformationCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'newTransformationCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'newTransformationViewed' track call.
 *
 * @param {NewTransformationViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function newTransformationViewed(
  props?: NewTransformationViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'newTransformationViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'resourceAlertsViewed' track call.
 *
 * @param {ResourceAlertsViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function resourceAlertsViewed(
  props?: ResourceAlertsViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'resourceAlertsViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'resourceSelected' track call.
 *
 * @param {ResourceSelected} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function resourceSelected(
  props?: ResourceSelected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'resourceSelected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'sourceCreated' track call.
 *
 * @param {SourceCreated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceCreated(
  props?: SourceCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'sourceDeleted' track call.
 *
 * @param {SourceDeleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceDeleted(
  props?: SourceDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'sourceDisabled' track call.
 *
 * @param {SourceDisabled} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceDisabled(
  props?: SourceDisabled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceDisabled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'sourceSetupStarted' track call.
 *
 * @param {SourceSetupStarted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceSetupStarted(
  props?: SourceSetupStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceSetupStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'sourceSetupStepCompleted' track call.
 *
 * @param {SourceSetupStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceSetupStepCompleted(
  props?: SourceSetupStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceSetupStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'trackingPlanConnected' track call.
 *
 * @param {TrackingPlanConnected} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanConnected(
  props?: TrackingPlanConnected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanConnected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'trackingPlanCreated' track call.
 *
 * @param {TrackingPlanCreated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanCreated(
  props?: TrackingPlanCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'trackingPlanDraftCreated' track call.
 *
 * @param {TrackingPlanDraftCreated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanDraftCreated(
  props?: TrackingPlanDraftCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanDraftCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'trackingPlanDropEventsTriggered' track call.
 *
 * @param {TrackingPlanDropEventsTriggered} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanDropEventsTriggered(
  props?: TrackingPlanDropEventsTriggered,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanDropEventsTriggered',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'trackingPlanEdited' track call.
 *
 * @param {TrackingPlanEdited} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanEdited(
  props?: TrackingPlanEdited,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanEdited',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'trackingPlanEventsViewed' track call.
 *
 * @param {TrackingPlanEventsViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanEventsViewed(
  props?: TrackingPlanEventsViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanEventsViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationConnectedToDestination' track call.
 *
 * @param {TransformationConnectedToDestination} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationConnectedToDestination(
  props?: TransformationConnectedToDestination,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationConnectedToDestination',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationDeleted' track call.
 *
 * @param {TransformationDeleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationDeleted(
  props?: TransformationDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationDiffViewed' track call.
 *
 * @param {TransformationDiffViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationDiffViewed(
  props?: TransformationDiffViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationDiffViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationDisconnectedFromDestination' track call.
 *
 * @param {TransformationDisconnectedFromDestination} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationDisconnectedFromDestination(
  props?: TransformationDisconnectedFromDestination,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationDisconnectedFromDestination',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationEventsPageViewed' track call.
 *
 * @param {TransformationEventsPageViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationEventsPageViewed(
  props?: TransformationEventsPageViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationEventsPageViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationLibraryCreated' track call.
 *
 * @param {TransformationLibraryCreated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationLibraryCreated(
  props?: TransformationLibraryCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationLibraryCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationLogs' track call.
 *
 * @param {TransformationLogs} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationLogs(
  props?: TransformationLogs,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationLogs',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationSplitScreen' track call.
 *
 * @param {TransformationSplitScreen} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationSplitScreen(
  props?: TransformationSplitScreen,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationSplitScreen',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'transformationTested' track call.
 *
 * @param {TransformationTested} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationTested(
  props?: TransformationTested,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationTested',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'userCompletedOnboarding' track call.
 *
 * @param {UserCompletedOnboarding} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function userCompletedOnboarding(
  props?: UserCompletedOnboarding,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'userCompletedOnboarding',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'viewedLiveEvents' track call.
 *
 * @param {ViewedLiveEvents} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function viewedLiveEvents(
  props?: ViewedLiveEvents,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'viewedLiveEvents',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Fires a 'workspaceAlertsViewed' track call.
 *
 * @param {WorkspaceAlertsViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function workspaceAlertsViewed(
  props?: WorkspaceAlertsViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'workspaceAlertsViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}

/**
 * Fires a 'identify' call.
 *
 * @param {string} [userId] - The user ID of the user.
 * @param {Identify} [traits] - The analytics traits that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function identify(
  userId: string,
  traits?: Identify,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function identify(
  traits?: Identify,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function identify(
  userIdOrTraits?: string | Identify,
  traitsOrOptions?: Identify | ApiOptions,
  optionsOrCallback?: ApiOptions | apiCallback,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    const userId =
      typeof userIdOrTraits === 'string' ? userIdOrTraits : undefined
    const traits =
      typeof userIdOrTraits === 'string'
        ? (traitsOrOptions as Identify)
        : (userIdOrTraits as Identify)
    const options =
      typeof userIdOrTraits === 'string'
        ? (optionsOrCallback as ApiOptions)
        : (traitsOrOptions as ApiOptions)
    const cb =
      typeof userIdOrTraits === 'string'
        ? callback
        : (optionsOrCallback as apiCallback)

    a.identify(userId, traits || {}, withRudderTyperContext(options), cb)
  }
}

/**
 * Fires a 'group' call.
 *
 * @param {string} [groupId] - The group ID of the group.
 * @param {Group} [traits] - The analytics traits that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function group(
  groupId: string,
  traits?: Group,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function group(
  traits?: Group,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function group(
  groupIdOrTraits?: string | Group,
  traitsOrOptions?: Group | ApiOptions,
  optionsOrCallback?: ApiOptions | apiCallback,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    if (typeof groupIdOrTraits === 'string') {
      const groupId = groupIdOrTraits
      const traits = (traitsOrOptions as Group) || {}
      const options = optionsOrCallback as ApiOptions
      a.group(groupId, traits, withRudderTyperContext(options), callback)
    } else {
      const traits = (groupIdOrTraits as Group) || {}
      const options = traitsOrOptions as ApiOptions
      const cb = optionsOrCallback as apiCallback
      a.group(traits, withRudderTyperContext(options), cb)
    }
  }
}

const clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions,
  /**
   * Fires a 'alertToggled' track call.
   *
   * @param {AlertToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  alertToggled,
  /**
   * This event is triggered when bot detection is enabled or disabled
   *
   * @param {BotDetectionToggled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  botDetectionToggled,
  /**
   * New event was added in the Data Catalog
   *
   * @param {CatalogAddNewEvent} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogAddNewEvent,
  /**
   * Fires a 'catalogAddNewProperty' track call.
   *
   * @param {CatalogAddNewProperty} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogAddNewProperty,
  /**
   * Fires a 'catalogDeleteEvent' track call.
   *
   * @param {CatalogDeleteEvent} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogDeleteEvent,
  /**
   * Fires a 'catalogDeleteProperty' track call.
   *
   * @param {CatalogDeleteProperty} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogDeleteProperty,
  /**
   * Fires a 'channelToggled' track call.
   *
   * @param {ChannelToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  channelToggled,
  /**
   * Fires a 'clickAddTrackingPlan' track call.
   *
   * @param {ClickAddTrackingPlan} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  clickAddTrackingPlan,
  /**
   * Fires a 'clickMigrateTrackingPlan' track call.
   *
   * @param {ClickMigrateTrackingPlan} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  clickMigrateTrackingPlan,
  /**
   * Fires a 'clickWebApp' track call.
   *
   * @param {ClickWebApp} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  clickWebApp,
  /**
   * Fires a 'destinationCreated' track call.
   *
   * @param {DestinationCreated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationCreated,
  /**
   * Fires a 'destinationDeleted' track call.
   *
   * @param {DestinationDeleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationDeleted,
  /**
   * Fires a 'destinationDisabled' track call.
   *
   * @param {DestinationDisabled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationDisabled,
  /**
   * Fires a 'destinationSetupStarted' track call.
   *
   * @param {DestinationSetupStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationSetupStarted,
  /**
   * Fires a 'destinationSetupStepCompleted' track call.
   *
   * @param {DestinationSetupStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationSetupStepCompleted,
  /**
   * Fires a 'gettingStartedChecklistCompleted' track call.
   *
   * @param {GettingStartedChecklistCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  gettingStartedChecklistCompleted,
  /**
   * Fires a 'healthTabViewed' track call.
   *
   * @param {HealthTabViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  healthTabViewed,
  /**
   * Fires a 'ideProjectCommit' track call.
   *
   * @param {IdeProjectCommit} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  ideProjectCommit,
  /**
   * Fires a 'ideProjectCreate' track call.
   *
   * @param {IdeProjectCreate} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  ideProjectCreate,
  /**
   * Fires a 'ideProjectOpen' track call.
   *
   * @param {IdeProjectOpen} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  ideProjectOpen,
  /**
   * Fires a 'ideProjectRun' track call.
   *
   * @param {IdeProjectRun} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  ideProjectRun,
  /**
   * Fires a 'ideProjectSave' track call.
   *
   * @param {IdeProjectSave} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  ideProjectSave,
  /**
   * Fires a 'login' track call.
   *
   * @param {Login} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  login,
  /**
   * Fires a 'newTransformationCreated' track call.
   *
   * @param {NewTransformationCreated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  newTransformationCreated,
  /**
   * Fires a 'newTransformationViewed' track call.
   *
   * @param {NewTransformationViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  newTransformationViewed,
  /**
   * Fires a 'resourceAlertsViewed' track call.
   *
   * @param {ResourceAlertsViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  resourceAlertsViewed,
  /**
   * Fires a 'resourceSelected' track call.
   *
   * @param {ResourceSelected} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  resourceSelected,
  /**
   * Fires a 'sourceCreated' track call.
   *
   * @param {SourceCreated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceCreated,
  /**
   * Fires a 'sourceDeleted' track call.
   *
   * @param {SourceDeleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceDeleted,
  /**
   * Fires a 'sourceDisabled' track call.
   *
   * @param {SourceDisabled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceDisabled,
  /**
   * Fires a 'sourceSetupStarted' track call.
   *
   * @param {SourceSetupStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceSetupStarted,
  /**
   * Fires a 'sourceSetupStepCompleted' track call.
   *
   * @param {SourceSetupStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceSetupStepCompleted,
  /**
   * Fires a 'trackingPlanConnected' track call.
   *
   * @param {TrackingPlanConnected} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanConnected,
  /**
   * Fires a 'trackingPlanCreated' track call.
   *
   * @param {TrackingPlanCreated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanCreated,
  /**
   * Fires a 'trackingPlanDraftCreated' track call.
   *
   * @param {TrackingPlanDraftCreated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanDraftCreated,
  /**
   * Fires a 'trackingPlanDropEventsTriggered' track call.
   *
   * @param {TrackingPlanDropEventsTriggered} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanDropEventsTriggered,
  /**
   * Fires a 'trackingPlanEdited' track call.
   *
   * @param {TrackingPlanEdited} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanEdited,
  /**
   * Fires a 'trackingPlanEventsViewed' track call.
   *
   * @param {TrackingPlanEventsViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanEventsViewed,
  /**
   * Fires a 'transformationConnectedToDestination' track call.
   *
   * @param {TransformationConnectedToDestination} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationConnectedToDestination,
  /**
   * Fires a 'transformationDeleted' track call.
   *
   * @param {TransformationDeleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationDeleted,
  /**
   * Fires a 'transformationDiffViewed' track call.
   *
   * @param {TransformationDiffViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationDiffViewed,
  /**
   * Fires a 'transformationDisconnectedFromDestination' track call.
   *
   * @param {TransformationDisconnectedFromDestination} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationDisconnectedFromDestination,
  /**
   * Fires a 'transformationEventsPageViewed' track call.
   *
   * @param {TransformationEventsPageViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationEventsPageViewed,
  /**
   * Fires a 'transformationLibraryCreated' track call.
   *
   * @param {TransformationLibraryCreated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationLibraryCreated,
  /**
   * Fires a 'transformationLogs' track call.
   *
   * @param {TransformationLogs} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationLogs,
  /**
   * Fires a 'transformationSplitScreen' track call.
   *
   * @param {TransformationSplitScreen} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationSplitScreen,
  /**
   * Fires a 'transformationTested' track call.
   *
   * @param {TransformationTested} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationTested,
  /**
   * Fires a 'userCompletedOnboarding' track call.
   *
   * @param {UserCompletedOnboarding} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  userCompletedOnboarding,
  /**
   * Fires a 'viewedLiveEvents' track call.
   *
   * @param {ViewedLiveEvents} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  viewedLiveEvents,
  /**
   * Fires a 'workspaceAlertsViewed' track call.
   *
   * @param {WorkspaceAlertsViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  workspaceAlertsViewed,
  /**
   * Fires a 'identify' call.
   *
   * @param {string} [userId] - The user ID of the user.
   * @param {Identify} [traits] - The analytics traits that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  identify,
  /**
   * Fires a 'group' call.
   *
   * @param {string} [groupId] - The group ID of the group.
   * @param {Group} [traits] - The analytics traits that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  group,
}

export const RudderTyperAnalytics = new Proxy<typeof clientAPI>(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && Object.keys(target).includes(method)) {
      return target[method as keyof typeof clientAPI]
    }

    return () => {
      const a = analytics()
      if (a) {
        a.track(
          'Unknown Analytics Call Fired',
          {
            method,
          },
          withRudderTyperContext()
        )
      }
    }
  },
})
